export default "/8522fe2631ecefb1e3967be9883671f05392a386/a2cdf02300b2663230f496dbfe02b4a0.svg";